export default __webpack_public_path__ + "static/4-51870edf328c0e90c1b7621add115fa3.jpeg";